<!-- 原料 -->
<template>
  <div v-if="loaded" class="cont-box">
    <div v-if="false" class="cont-left">
      <div
        class="module-box"
        v-for="(itemNd, indexNd) in selfData.default_mo_kuai_list"
        :key="`${activeNavIndex}-${indexNd + selfData.custom_mo_kuai_list[activeNavIndex].list.length}`"
      >
        <div class="module-cont">
          <div class="form-list">
            <div class="form-item">
              <template v-if="itemNd.name === '所需物料'">
                <div class="form-top">
                  <div class="form-left">
                    <div class="form-name">{{ itemNd.name }}</div>
                    <el-button v-if="!disabled" type="primary" @click="wuLiaoChooseOne">
                      选择物料
                    </el-button>
                  </div>
                  <div class="form-right">
                    <span>共有</span>
                    <span class="f-bold c-red">
                      {{ selfData.wu_liao_choose_list.length }}
                    </span>
                    <span>项物料</span>
                  </div>
                </div>
                <!-- 第三层 字段 默认 所需物料 -->
                <!-- 表格 -->
                <vxe-grid
                  ref="refTableWuLiao"
                  v-bind="tableConfigWuLiao"
                  :data="selfData.wu_liao_choose_list"
                  :show-footer="true"
                  :footer-method="(event) => footerMethod(event, '物料')"
                >
                  <!-- slot_edit -->
                  <template #edit_dan_jian_shu_liang="{ row }">
                    <el-input
                      v-model="row.dan_jian_shu_liang"
                      type="number"
                      size="mini"
                      clearable
                      disabled
                      @blur="countsBlur(row)"
                    />
                  </template>
                  <!-- slot_default -->
                  <template #default_dan_wei="{ row }">
                    {{ $tool.getDanWei(row.dan_wei) }}
                  </template>
                  <template #default_operate="{ rowIndex }">
                    <el-link type="primary" @click="wuLiaoDetail(rowIndex)"> 详情 </el-link>
                    <el-link v-if="!disabled" type="danger" @click="wuLiaoDelete(rowIndex)">
                      删除
                    </el-link>
                  </template>
                </vxe-grid>
              </template>
              <template v-if="itemNd.name === '工艺路线'">
                <div class="form-top">
                  <div class="form-left">
                    <div class="form-name">{{ itemNd.name }}</div>
                    <el-button v-if="!disabled" type="success" @click="jiaGongInputOne()">
                      手动录入加工
                    </el-button>
                  </div>
                  <div class="form-right">
                    <span>共有</span>
                    <span class="f-bold c-red">
                      {{ selfData.jia_gong_choose_list.length }}
                    </span>
                    <span>项加工工艺</span>
                  </div>
                </div>
                <!-- 第三层 字段 默认 工艺路线 -->
                <!-- 表格 -->
                <vxe-grid
                  ref="refTableJiaGong"
                  v-bind="tableConfigJiaGong"
                  :data="selfData.jia_gong_choose_list"
                  :show-footer="true"
                  :footer-method="(event) => footerMethod(event, '加工')"
                >
                  <!-- slot_edit -->
                  <template #edit_dan_jian_shu_liang="{ row }">
                    <el-input
                      v-model="row.dan_jian_shu_liang"
                      type="number"
                      size="mini"
                      clearable
                      disabled
                      @blur="countsBlur(row)"
                    />
                  </template>
                  <!-- slot_default -->
                  <template #default_dan_wei="{ row }">
                    {{ $tool.getDanWei(row.dan_wei) }}
                  </template>
                  <template #default_operate="{ rowIndex }">
                    <el-link v-if="!disabled" type="success" @click="jiaGongInputOne(rowIndex)">
                      编辑
                    </el-link>
                    <el-link v-if="!disabled" type="danger" @click="jiaGongDelete(rowIndex)">
                      删除
                    </el-link>
                  </template>
                </vxe-grid>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cont-right">
      <div class="module-box">
        <TabsMoKuai :list="tabNavList" :index.sync="activeNavIndex" />
        <div class="edit-base-price">
          <span>修改基价：</span>
          <div>
            <el-input
              v-model="selfData.ji_chu_jia_ge"
              type="number"
              size="mini"
              clearable
              @input="actionVerify"
            >
              <span v-if="selfData.mo_ren_dan_wei_zu" slot="suffix">
                元/{{ selfData.mo_ren_dan_wei_zu.split(',')[0] }}
              </span>
            </el-input>
          </div>
        </div>
        <div class="module-cont">
          <!-- 第二层 表单 -->
          <div
            v-if="
              selfData.custom_mo_kuai_list[activeNavIndex] &&
              selfData.custom_mo_kuai_list[activeNavIndex].list
            "
            class="form-list"
          >
            <div
              class="form-item"
              :class="!activeNavIndex ? 'is-first' : ''"
              v-for="(itemNd, indexNd) in selfData.custom_mo_kuai_list[activeNavIndex].list"
              :key="`${activeNavIndex}-${indexNd}`"
            >
              <div v-if="!activeNavIndex" class="form-top form-other">
                <div class="form-left">
                  <div class="form-name">其他信息</div>
                </div>
              </div>
              <div class="form-top">
                <div class="form-left">
                  <div class="form-name">{{ itemNd.name }}</div>
                  <!-- 单价计算方式 -->
                  <el-select
                    v-if="false"
                    class="dan-jia-list"
                    v-model="selfData.dan_jia_lei_xing"
                    :disabled="disabled"
                  >
                    <el-option
                      v-for="(itemDanJia, indexDanJia) in danJiaList"
                      :key="indexDanJia"
                      :label="itemDanJia.key"
                      :value="itemDanJia.val"
                    />
                  </el-select>
                </div>
              </div>
              <!-- 第三层 字段 自定义 商品信息 -->
              <div class="zi-duan-list" v-if="itemNd.is_show">
                <div class="p-t-10 p-l-10">
                  <CustomZiDuan
                    :key="`${activeNavIndex}-${indexNd}`"
                    :isFirst="!activeNavIndex"
                    :guiGeList="selfData.gui_ge_list"
                    :list.sync="itemNd.list"
                    :disabled="disabled"
                    :top="fujiaHeight"
                    @change="actionVerify"
                  />
                </div>
              </div>
            </div>
            <div
              ref="refFormFujia"
              class="form-item form-fujia"
              v-if="!activeNavIndex && selfData.fu_jia_can_shu_list.length"
            >
              <div class="form-top">
                <div class="form-left">
                  <div class="form-name">附加参数</div>
                  <e-upload-image :list="selfData.can_shu_tu_pian" size="24px" disabled />
                </div>
              </div>
              <!-- 第三层 字段 自定义 商品信息 -->
              <div class="zi-duan-list">
                <div class="p-t-10 p-l-10">
                  <CustomZiDuan
                    :guiGeList="selfData.gui_ge_list"
                    :list.sync="selfData.fu_jia_can_shu_list"
                    :disabled="disabled"
                    @change="actionVerify"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    TabsMoKuai: () => import('./tabs-mo-kuai'),
    CustomZiDuan: () => import('./custom-zi-duan')
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loaded: false,
      selfData: {},
      fujiaHeight: '0px',
      otherHeight: '0px',

      // 选项卡-相关字段
      activeNavIndex: 0,

      danJiaList: [
        {
          key: '商品单价 = 模板公式单价 + 工艺路线单价',
          val: '0'
        },
        {
          key: '商品单价 = 所需物料单价 + 工艺路线单价',
          val: '1'
        },
        {
          key: '商品单价 = 模板公式单价',
          val: '2'
        },
        {
          key: '商品单价 = 所需物料单价',
          val: '3'
        },
        {
          key: '商品单价 = 工艺路线单价',
          val: '4'
        }
      ],

      // 校验-相关字段
      verifyTimer: null,

      // 汇总相关字段
      totalObj: {
        type: '', // 单价类型
        dan_jian_shu_liang: 0, // 单件数量
        zong_shu_liang: 0, // 数量
        gong_shi_price: 0, // 模板公式单价
        wu_liao_amount: 0, // 所需物料金额
        jia_gong_amount: 0 // 工艺路线金额
      }
    }
  },
  computed: {
    // 选项卡菜单列表
    tabNavList() {
      let result = []
      if (this.selfData.custom_mo_kuai_list.length) {
        result = this.selfData.custom_mo_kuai_list.map((item, index) => {
          return {
            key: item.name,
            val: JSON.stringify(index)
          }
        })
      }
      return result
    },
    // 表格配置合并
    tableConfigWuLiao() {
      let disabled = this.disabled
      let obj = {
        height: '260px',
        columns: [
          { field: 'shang_pin_ming_cheng', title: '商品名称', width: 160 },
          { field: 'gui_ge_shi_li', title: '规格', width: 160 },
          { field: 'dan_wei', title: '单位', width: 80, slots: { default: 'default_dan_wei' } },
          {
            field: 'dan_jian_shu_liang',
            title: '单件数量',
            width: 80
            // slots: { edit: 'edit_dan_jian_shu_liang' },
            // editRender: { autofocus: '.el-input__inner' }
          },
          { field: 'dan_jia', title: '单价(元)', width: 120 },
          { field: 'dan_jian_jin_e', title: '单件金额(元)', width: 120 },
          { title: '操作', slots: { default: 'default_operate' } }
        ],
        editConfig: {
          beforeEditMethod() {
            return !disabled
          }
        },
        keyboardConfig: {
          isEdit: !disabled
        }
      }
      let result = this.$util.deepMerge(this.$constant.tableDefaultConfig, obj)
      return result
    },
    // 表格配置合并
    tableConfigJiaGong() {
      let disabled = this.disabled
      let obj = {
        height: '260px',
        columns: [
          { field: 'mu_ban_ming_cheng', title: '模板名称', width: 160 },
          { field: 'gui_ge_shi_li', title: '规格', width: 160 },
          { field: 'dan_wei', title: '单位', width: 80, slots: { default: 'default_dan_wei' } },
          {
            field: 'dan_jian_shu_liang',
            title: '单件数量',
            width: 80
            // slots: { edit: 'edit_dan_jian_shu_liang' },
            // editRender: { autofocus: '.el-input__inner' }
          },
          { field: 'dan_jia', title: '单价(元)', width: 120 },
          { field: 'dan_jian_jin_e', title: '单件金额(元)', width: 120 },
          { title: '操作', slots: { default: 'default_operate' } }
        ],
        editConfig: {
          beforeEditMethod() {
            return !disabled
          }
        },
        keyboardConfig: {
          isEdit: !disabled
        }
      }
      let result = this.$util.deepMerge(this.$constant.tableDefaultConfig, obj)
      return result
    }
  },
  watch: {
    loaded(val) {
      if (val) {
        setTimeout(() => {
          if (this.$refs.refFormFujia) {
            this.fujiaHeight = `${this.$refs.refFormFujia.clientHeight + 60}px`
            this.otherHeight = `${this.$refs.refFormFujia.clientHeight + 98}px`
          } else {
            this.fujiaHeight = '40px'
            this.otherHeight = '78px'
          }
        })
      }
    },
    data: {
      handler(val) {
        if (JSON.stringify(this.selfData) !== JSON.stringify(val)) {
          this.loaded = false
          this.selfData = this.$util.deepCopy(val)
          this.loaded = true
        }
      },
      deep: true,
      immediate: true
    },
    selfData: {
      handler(val) {
        if (JSON.stringify(this.data) !== JSON.stringify(val)) {
          let result = this.$util.deepCopy(val)
          this.$emit('update:data', result)
        }
      },
      deep: true,
      immediate: true
    },
    'selfData.dan_jia_lei_xing': {
      handler(val) {
        this.totalObj.type = val
      },
      deep: true,
      immediate: true
    },
    // 合计对象
    totalObj: {
      handler(val) {
        /**
         * ① 模板公式单价 val.gong_shi_price
         * ② 所需物料单价 wu_liao_price = val.wu_liao_amount / val.dan_jian_shu_liang
         * ③ 工艺路线单价 jia_gong_price = val.jia_gong_amount / val.dan_jian_shu_liang
         */
        let single_price = 0
        let wu_liao_price = this.$XEUtils.divide(val.wu_liao_amount, val.dan_jian_shu_liang)
        let jia_gong_price = this.$XEUtils.divide(val.jia_gong_amount, val.dan_jian_shu_liang)
        if (val.type === '0') single_price = this.$XEUtils.add(val.gong_shi_price, jia_gong_price) // ① + ③
        if (val.type === '1') single_price = this.$XEUtils.add(wu_liao_price, jia_gong_price) // ② + ③
        if (val.type === '2') single_price = val.gong_shi_price // ①
        if (val.type === '3') single_price = wu_liao_price // ②
        if (val.type === '4') single_price = jia_gong_price // ③

        // 设置单价、单件金额
        this.selfData.custom_mo_kuai_list[0].list[0].list.forEach((field) => {
          if (field.name === '单价') field.value = single_price
          if (field.name === '单件金额')
            field.value = this.$XEUtils.multiply(single_price, val.dan_jian_shu_liang)
          if (field.name === '金额')
            field.value = this.$XEUtils.multiply(single_price, val.zong_shu_liang)
        })
      },
      deep: true
    }
  },
  methods: {
    // 校验数据----------------------------------------------
    // 开始校验
    actionVerify() {
      if (this.verifyTimer) clearTimeout(this.verifyTimer)
      this.verifyTimer = setTimeout(() => {
        this.confirmVerify()
        this.verifyTimer = null
      }, 20)
    },
    // 确认校验
    confirmVerify() {
      // 设置输入的规格
      this.selfData.custom_mo_kuai_list[0].list[0].list.forEach((item) => {
        if (item.name === '规格') {
          this.selfData.gui_ge_shi_li = item.value
        }
      })

      // 校验规格
      if (!this.selfData.gui_ge_shi_li) {
        // this.$message.error('请输入规格')
        return
      }

      // 规格含闭合括号（中英文）：公式自动计算不准确，数量/单价/金额改手动输入，不再自动改写
      if (this.$tool.hasBracket(this.selfData.gui_ge_shi_li)) {
        return
      }

      // 校验规格格式
      let guigeList = this.selfData.gui_ge_shi_li.split('*')
      if (
        guigeList.length !== this.selfData.gui_ge_list.length ||
        guigeList[guigeList.length - 1] === ''
      ) {
        // this.$message.error('规格格式不匹配')
        return
      }

      // 对象参数------------------------------------------
      let objCs = {
        密度: this.selfData.mi_du_shi_li
      }
      this.selfData.gui_ge_list.forEach((item, index) => (objCs[item] = guigeList[index]))
      this.selfData.fu_jia_can_shu_list.forEach((item, index) => {
        objCs[item.name] = item.value
        this.selfData.fu_jia_can_shu_shi_li[index] = item.value
      })

      // 可编辑公式字段处理
      this.selfData.custom_mo_kuai_list.forEach((itemSt) => {
        itemSt.list.forEach((itemNd) => {
          itemNd.list.forEach((itemRd) => {
            let isEditOfficle = itemRd.lei_xing_id === 11 && itemRd.is_edit && itemRd.is_set
            if (isEditOfficle) {
              itemRd.value = this.$tool.gongShiResult(itemRd.set_gong_shi, objCs) // 使用：公式计算
            }
          })
        })
      })

      // 基础产量示例浮动处理------------------------------------------
      let resultChanLiangShuzhi = 0
      let resultChanLiangBili = 0
      let effectJiChuChanLiangList = []
      this.selfData.ji_chu_chan_liang_list.forEach((itemSt, indexSt) => {
        itemSt.forEach((itemNd) => {
          // 获取有效的浮动列表
          let resA =
            itemNd.tiao_zheng_key_list.length && itemNd.tiao_zheng_type && itemNd.tiao_zheng_val
          let resB = false
          if (indexSt) {
            resB = !!itemNd.tiao_zheng_scope_val
          } else {
            resB = itemNd.tiao_zheng_scope_start || itemNd.tiao_zheng_scope_end
          }
          if (resA && resB) {
            effectJiChuChanLiangList.push({ ...itemNd, type: indexSt })
          }
        })
      })
      effectJiChuChanLiangList.forEach((item) => {
        let resultComparePass = false
        // 0：参数范围
        if (item.type === 0) {
          let key = item.tiao_zheng_key_list[0]
          let tiaoZhengObj = {
            key: key,
            val: objCs[key]
          }
          let resultCompareS = Number(tiaoZhengObj.val) >= Number(item.tiao_zheng_scope_start) // 对比开始值
          let resultCompareE = Number(tiaoZhengObj.val) <= Number(item.tiao_zheng_scope_end) // 对比结束值
          if (item.tiao_zheng_scope_start && !item.tiao_zheng_scope_end) {
            resultComparePass = resultCompareS
          }
          if (!item.tiao_zheng_scope_start && item.tiao_zheng_scope_end) {
            resultComparePass = resultCompareE
          }
          if (item.tiao_zheng_scope_start && item.tiao_zheng_scope_end) {
            resultComparePass = resultCompareS && resultCompareE
          }
        }
        // 1：参数匹配
        if (item.type === 1) {
          let symbolStr = this.$constant.pipeiSymbolList[0]
          this.$constant.pipeiSymbolList.forEach((itemSymbol) => {
            if (item.tiao_zheng_scope_val.includes(itemSymbol)) symbolStr = itemSymbol
          })
          let piPeiList = item.tiao_zheng_scope_val.split(symbolStr)
          let tiaoZhengList = item.tiao_zheng_key_list.map((itemKey) => objCs[itemKey])
          let sortPiPeiList = piPeiList.sort((a, b) => a - b)
          let sortTiaoZhengList = tiaoZhengList.sort((a, b) => a - b)
          resultComparePass = sortPiPeiList.join(',') === sortTiaoZhengList.join(',')
        }

        if (!resultComparePass) return
        if (item.tiao_zheng_type === '0') {
          resultChanLiangShuzhi = this.$XEUtils.add(resultChanLiangShuzhi, item.tiao_zheng_val) // 上调数值
        }
        if (item.tiao_zheng_type === '1') {
          resultChanLiangShuzhi = this.$XEUtils.subtract(resultChanLiangShuzhi, item.tiao_zheng_val) // 下调数值
        }
        if (item.tiao_zheng_type === '2') {
          let result = this.$XEUtils.multiply(
            this.selfData.ji_chu_chan_liang,
            item.tiao_zheng_val / 100
          )
          resultChanLiangBili = this.$XEUtils.add(resultChanLiangBili, result) // 上调比例
        }
        if (item.tiao_zheng_type === '3') {
          let result = this.$XEUtils.multiply(
            this.selfData.ji_chu_chan_liang,
            item.tiao_zheng_val / 100
          )
          resultChanLiangBili = this.$XEUtils.subtract(resultChanLiangBili, result) // 下调比例
        }
      })
      this.selfData.chan_liang_shi_li = this.selfData.ji_chu_chan_liang // 产量示例
      this.selfData.chan_liang_shi_li = this.$XEUtils.add(
        this.selfData.chan_liang_shi_li,
        resultChanLiangShuzhi
      ) // 加数值
      this.selfData.chan_liang_shi_li = this.$XEUtils.add(
        this.selfData.chan_liang_shi_li,
        resultChanLiangBili
      ) // 加比例

      // 基础价格示例浮动处理------------------------------------------
      let resultJiJiaShuzhi = 0
      let resultJiJiaBili = 0
      let effectJiChuJiaGeList = []
      this.selfData.ji_chu_jia_ge_list.forEach((itemSt, indexSt) => {
        itemSt.forEach((itemNd) => {
          // 获取有效的浮动列表
          let resA =
            itemNd.tiao_zheng_key_list.length && itemNd.tiao_zheng_type && itemNd.tiao_zheng_val
          let resB = false
          if (indexSt) {
            resB = !!itemNd.tiao_zheng_scope_val
          } else {
            resB = itemNd.tiao_zheng_scope_start || itemNd.tiao_zheng_scope_end
          }
          if (resA && resB) {
            effectJiChuJiaGeList.push({ ...itemNd, type: indexSt })
          }
        })
      })
      effectJiChuJiaGeList.forEach((item) => {
        let resultComparePass = false
        // 0：参数范围
        if (item.type === 0) {
          let key = item.tiao_zheng_key_list[0]
          let tiaoZhengObj = {
            key: key,
            val: objCs[key]
          }
          let resultCompareS = Number(tiaoZhengObj.val) >= Number(item.tiao_zheng_scope_start) // 对比开始值
          let resultCompareE = Number(tiaoZhengObj.val) <= Number(item.tiao_zheng_scope_end) // 对比结束值
          if (item.tiao_zheng_scope_start && !item.tiao_zheng_scope_end) {
            resultComparePass = resultCompareS
          }
          if (!item.tiao_zheng_scope_start && item.tiao_zheng_scope_end) {
            resultComparePass = resultCompareE
          }
          if (item.tiao_zheng_scope_start && item.tiao_zheng_scope_end) {
            resultComparePass = resultCompareS && resultCompareE
          }
        }
        // 1：参数匹配
        if (item.type === 1) {
          let symbolStr = this.$constant.pipeiSymbolList[0]
          this.$constant.pipeiSymbolList.forEach((itemSymbol) => {
            if (item.tiao_zheng_scope_val.includes(itemSymbol)) symbolStr = itemSymbol
          })
          let piPeiList = item.tiao_zheng_scope_val.split(symbolStr)
          let tiaoZhengList = item.tiao_zheng_key_list.map((itemKey) => objCs[itemKey])
          let sortPiPeiList = piPeiList.sort((a, b) => a - b)
          let sortTiaoZhengList = tiaoZhengList.sort((a, b) => a - b)
          resultComparePass = sortPiPeiList.join(',') === sortTiaoZhengList.join(',')
        }

        if (!resultComparePass) return
        if (item.tiao_zheng_type === '0') {
          resultJiJiaShuzhi = this.$XEUtils.add(resultJiJiaShuzhi, item.tiao_zheng_val) // 上调数值
        }
        if (item.tiao_zheng_type === '1') {
          resultJiJiaShuzhi = this.$XEUtils.subtract(resultJiJiaShuzhi, item.tiao_zheng_val) // 下调数值
        }
        if (item.tiao_zheng_type === '2') {
          let result = this.$XEUtils.multiply(
            this.selfData.ji_chu_jia_ge,
            item.tiao_zheng_val / 100
          )
          resultJiJiaBili = this.$XEUtils.add(resultJiJiaBili, result) // 上调比例
        }
        if (item.tiao_zheng_type === '3') {
          let result = this.$XEUtils.multiply(
            this.selfData.ji_chu_jia_ge,
            item.tiao_zheng_val / 100
          )
          resultJiJiaBili = this.$XEUtils.subtract(resultJiJiaBili, result) // 下调比例
        }
      })
      this.selfData.ji_jia_shi_li = this.selfData.ji_chu_jia_ge // 基价示例
      this.selfData.ji_jia_shi_li = this.$XEUtils.add(
        this.selfData.ji_jia_shi_li,
        resultJiJiaShuzhi
      ) // 加数值
      this.selfData.ji_jia_shi_li = this.$XEUtils.add(this.selfData.ji_jia_shi_li, resultJiJiaBili) // 加比例

      // 单位组-单位参数校验------------------------------------------
      this.selfData.dan_wei_zu_list.forEach((itemSt) => {
        // 主计量-单位参数校验
        let main_verify_unit_val = ''
        itemSt.dan_wei_list.forEach((itemNd) => {
          if (itemNd.is_zhu_ji_liang) {
            let result = ''
            if (itemSt.dan_wei_zu_name === '时间') {
              result = this.$XEUtils.divide(1, this.selfData.chan_liang_shi_li) // 使用：1/产量示例
            } else {
              result = this.$tool.gongShiResult(itemSt.gong_shi_list, objCs) // 使用：公式计算
            }
            itemNd.verify_unit_val = result
            main_verify_unit_val = result
          }
        })
        // 辅计量-单位参数校验
        itemSt.dan_wei_list.forEach((itemNd) => {
          if (!itemNd.is_zhu_ji_liang) {
            itemNd.verify_unit_val = this.$XEUtils.multiply(
              main_verify_unit_val,
              itemNd.zhuan_huan_zhi
            )
          }
        })
      })

      // 单位组-单价参数校验------------------------------------------
      let default_guige_price_val = ''
      this.selfData.dan_wei_zu_list.forEach((itemSt) => {
        // 默认单位-单价
        itemSt.dan_wei_list.forEach((itemNd) => {
          if (itemNd.is_mo_ren_dan_wei) {
            default_guige_price_val = this.$XEUtils.multiply(
              itemNd.verify_unit_val,
              this.selfData.ji_jia_shi_li
            )
          }
        })
      })
      this.selfData.dan_wei_zu_list.forEach((itemSt) => {
        // 所有单位-单价
        itemSt.dan_wei_list.forEach((itemNd) => {
          itemNd.verify_price_val = this.$XEUtils.divide(
            default_guige_price_val,
            itemNd.verify_unit_val
          )
        })
      })

      // 获取选中单位的单价
      let newDanJianShuLiang = 1
      let oldDanJianShuLiang = 1
      this.selfData.custom_mo_kuai_list[0].list[0].list.forEach((field) => {
        if (field.name === '单位') {
          this.selfData.dan_wei_zu_list.forEach((itemSt) => {
            itemSt.dan_wei_list.forEach((itemNd) => {
              let mergeName = `${itemNd.dan_wei_name},${itemSt.dan_wei_zu_name}`
              if (mergeName === field.value) {
                this.totalObj.gong_shi_price = this.$util.getNumberFullString(
                  itemNd.verify_price_val
                )
                this.totalObj.dan_jian_shu_liang = this.$util.getNumberFullString(
                  itemNd.verify_unit_val
                )
              }
            })
          })
        }
        // 设置单件数量
        if (field.name === '单件数量') {
          newDanJianShuLiang = this.totalObj.dan_jian_shu_liang
          oldDanJianShuLiang = field.value
          field.value = newDanJianShuLiang
        }
        // 设置数量
        if (field.name === '数量') {
          let result = this.$XEUtils.divide(
            this.$XEUtils.multiply(field.value, newDanJianShuLiang),
            oldDanJianShuLiang
          )
          field.value = result
          this.totalObj.zong_shu_liang = result
        }
      })
    },

    // 选择物料----------------------------------------------
    // 选择单个物料
    wuLiaoChooseOne() {
      this.$emit('wuLiaoChooseOne')
    },
    // 物料详情
    wuLiaoDetail(index) {
      let data = this.selfData.wu_liao_choose_list[index]
      this.$emit('wuLiaoDetail', data)
    },
    // 物料删除
    wuLiaoDelete(index) {
      this.selfData.wu_liao_choose_list.splice(index, 1)
    },

    // 选择加工----------------------------------------------
    // 选择多个加工
    jiaGongInputOne(index = '') {
      this.$emit('jiaGongInputOne', index)
    },
    // 加工删除
    jiaGongDelete(index) {
      this.selfData.jia_gong_choose_list.splice(index, 1)
    },

    // 其他----------------------------------------------
    // 表格底部
    footerMethod({ columns, data }, type) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (['dan_jian_jin_e'].includes(column.field)) {
            let result = this.$util.listFieldTotal(data, column.field)
            if (type === '物料') this.totalObj.wu_liao_amount = result
            if (type === '加工') this.totalObj.jia_gong_amount = result
            return result
          }
        })
      ]
    },
    // 单件数量-失焦
    countsBlur(row) {
      row.dan_jian_jin_e = this.$XEUtils.multiply(row.dan_jia, row.dan_jian_shu_liang)
    }
  }
}
</script>

<style lang="less" scoped>
.cont-box {
  display: flex;
  .cont-left {
    width: 838px;
    margin-right: 10px;
  }
  .cont-right {
    width: 1032px;
    .module-box {
      border: 1px solid @colorGrayD;
      border-radius: 3px;
      .module-cont {
        height: 534px;
        padding: 10px;
      }
    }
  }
  .module-box {
    position: relative;
    .edit-base-price {
      position: absolute;
      top: 1px;
      right: 5px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    & ~ .module-box {
      margin-top: 10px;
    }
    .module-cont {
      overflow: auto;
      .scroll-bar();
      .form-list {
        position: relative;
        font-size: 12px;
        color: @colorGrayDeep;
        .form-item {
          &.is-first {
            position: relative;
            .form-top {
              &.form-other {
                position: absolute;
                top: v-bind(otherHeight);
                width: 100%;
              }
            }
            .zi-duan-list {
              margin-top: 0;
            }
          }
          &.form-fujia {
            position: absolute;
            top: 78px;
            width: 100%;
          }
          .form-top {
            position: relative;
            z-index: 9;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid @colorGrayD;
            margin-bottom: -1px;

            .form-left {
              display: flex;
              align-items: center;
              .form-name {
                min-width: 59px;
                padding: 5px;
                margin-right: 5px;
                line-height: 18px;
                text-align: center;
                font-weight: bold;
                color: @colorGray;
                background: @colorGrayE;
                border: 1px solid @colorGrayD;
                border-bottom: none;
                border-radius: 3px 3px 0 0;
              }
              /deep/ .el-button {
                height: 24px;
                line-height: 24px;
                padding: 0 5px;
                font-size: 12px;
              }
            }
          }
          .zi-duan-list {
            display: flex;
            min-width: 250px;
            min-height: 28px;
          }
        }
      }
    }
    .dan-jia-list {
      width: 254px;
      margin-right: 5px;
      /deep/ .el-input__inner,
      /deep/ .el-input__icon {
        height: 24px;
        line-height: 24px;
      }
    }
  }
}
</style>
